import MobileAccordianCommon from "components/searchBar/mobile-tablet-view/accordian-common/MobileAccordianCommon";
import SearchLocationInput from "components/searchBar/mobile-tablet-view/SearchLocation/SearchLocationInput";
import { useAppSelector } from "stores/hooks";
import { selectLocalSearchLocation } from "stores/local-search/localSearchSlice";

// The accordion component for the location search input on the mobile view of the search bar
const LocationAccordian = ({
  isSearchCleared,
  setIsSearchCleared
}: {
  isSearchCleared: boolean;
  setIsSearchCleared: (value: boolean) => void;
}) => {
  const localSearchLocation = useAppSelector(selectLocalSearchLocation);
  return <MobileAccordianCommon currentTab='location' title='Where to?' className='max-h-[450px] px-4 pb-4' additionalSummaryContent={localSearchLocation.longName && <p className='line-clamp-2 text-right text-sm font-semibold leading-5 tracking-[-0.14px] text-[#26262B]'>
            {localSearchLocation.longName}
          </p>} data-sentry-element="MobileAccordianCommon" data-sentry-component="LocationAccordian" data-sentry-source-file="LocationAccordian.tsx">
      {/* Accordion content, containing the location search input */}
      <SearchLocationInput haveIcon={true} isSearchCleared={isSearchCleared} setIsSearchCleared={setIsSearchCleared} data-sentry-element="SearchLocationInput" data-sentry-source-file="LocationAccordian.tsx" />
    </MobileAccordianCommon>;
};
export default LocationAccordian;